import { SanityGraphQLResponse } from 'types/sanity';
import { useQuery } from 'villus';
import { villusClient } from '@utils/villus';
import { WhyFundrisePageData } from 'types/sanity/why-fundrise';
import { WhyFundrisePageQuery } from './queries/why-fundrise-page';

type SanityWhyFundrisePageResponse = SanityGraphQLResponse<WhyFundrisePageData, 'allWhyFundrisePage'>;

export async function getWhyFundriseSanityPage(): Promise<WhyFundrisePageData | null> {
	const { data } = await useQuery<SanityWhyFundrisePageResponse>({
		client: villusClient,
		query: WhyFundrisePageQuery,
		tags: ['why_fundrise_page']
	}).execute();

	return data?.allWhyFundrisePage[0] ?? null;
}
